import { SC } from "../helper/ServerCall";

export const customerService = {
    storeCustomer,
    updateCustomer,
    getCustomerPagination,
    deleteCustomer,
    storeCustomerAddress,
    getCustomerAddressesPagination,
    getAddressItem,
    deleteAddress,
    editCustomerAddress,
    getCustomer,
    getCustomersDropdown,
    approveCustomer
};

function editCustomerAddress(data, id) {
    return SC.putCall("customers/update-address/" + id, data);
}

function getCustomer(id) {
    return SC.getCall("customer/" + id);
}

function deleteAddress(list_id) {
    return SC.deleteCall("customers/delete-address/" + list_id);
}

function getAddressItem(id) {
    return SC.getCall(`customers/get-address/${id}`);
}

function storeCustomerAddress(data) {
    return SC.postCall(`customers/save-address`, data);
}

function deleteCustomer(id) {
    return SC.deleteCall(`customer/` + id);
}

function storeCustomer(data) {
    return SC.postCall(`customer`, data);
}

function updateCustomer(data, id) {
    return SC.putCall("customer/" + id, data);
}

function getCustomerPagination(page, filter, sort, pageSize, status) {
    return SC.getCall(
        "customer?page=" +
        page +
        "&filter=" +
        filter +
        "&sort=" +
        sort +
        "&pageSize=" +
        pageSize +
        "&status=" +
        status +
        "&paginate=" +
        true
    );
}

function getCustomersDropdown(page, filter, sort, pageSize) {
    return SC.getCall("get-all-customers");
}

function getCustomerAddressesPagination(
    id,
    page,
    sort,
    pageSize,
    component_name,
    pagination
) {
    return SC.getCall(
        "customers/get-addresses?id=" +
        id +
        "&page=" +
        page +
        "&sort=" +
        sort +
        "&pageSize=" +
        pageSize +
        "&component_name=" +
        component_name +
        "&pagination=" +
        pagination
    );
}

function approveCustomer(id) {
    return SC.postCall(`approve/customer/${id}`);
}



// WEBPACK FOOTER //
// ./src/services/customer.js